// extracted by mini-css-extract-plugin
module.exports = {"theme":"#eebb4e"};